import type { ICellRendererParams } from "ag-grid-community";
import { EllipsisVerticalIcon } from "lucide-react";

import { ContextMenu } from "@/components/ui/ContextMenu";
import type { ContextMenuItems } from "@/components/ui/ContextMenu/types";
import type { BaseData } from "@/components/ui/ag-grid-table";
import type { TableColumn } from "@/components/ui/TableV2/types";
import { cn } from "@/lib/utils";

const ACTIONS_COLUMN_WIDTH = 52;

export const createActionsColumn = <TRow extends BaseData>(
  contextMenuItems: ContextMenuItems<TRow>[] | undefined,
  id: number,
): TableColumn<TRow> => ({
  id,
  name: "actions",
  header: "",
  width: ACTIONS_COLUMN_WIDTH,
  minWidth: ACTIONS_COLUMN_WIDTH,
  maxWidth: ACTIONS_COLUMN_WIDTH,
  sortable: false,
  resizable: false,
  suppressMovable: true,
  pinned: "right",
  lockPinned: true,
  cellClass:
    "!justify-center [&_.ag-cell-wrapper]:!justify-center [&_.ag-cell-value]:!justify-center",
  headerClass:
    "[&_.ag-cell-label-container]:!justify-center [&_.ag-header-cell-label]:!justify-center [&_.ag-header-cell-comp-wrapper]:!justify-center",
  cellRenderer: ({ data }: ICellRendererParams<TRow>) => {
    if (!data) {
      return null;
    }

    return (
      <div
        className="flex h-full w-full items-center justify-center"
        onClick={event => event.stopPropagation()}
        onMouseDown={event => event.stopPropagation()}
      >
        <ContextMenu<TRow>
          data={data}
          modal={false}
          usePortal
          shouldOpenContextMenuByLeftClick
          isDisabled={!contextMenuItems?.length}
          contextMenuItems={contextMenuItems ?? []}
          className="flex h-8 w-8 items-center justify-center"
        >
          <button
            type="button"
            aria-label="Open row actions"
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-md text-gray-500",
              "hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            )}
          >
            <EllipsisVerticalIcon className="h-4 w-4" />
          </button>
        </ContextMenu>
      </div>
    );
  },
});
